var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-cta"},[_c('div',{staticClass:"business-cta__content"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))]),_c('LangRouterLink',{attrs:{"to":{ name: 'home' }}},[_vm._v(_vm._s(_vm.linkLabel))])],1),_c('div',{staticClass:"business-cta__image"})])
}
var staticRenderFns = []

export { render, staticRenderFns }